<template>
  <b-card style="padding:40px;">
    <h5><b>STOCKOUT BY DAY</b></h5>
    <hr />
    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Full Name</label>
          <b-form-input
            v-model="form.name"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role_code`">Date</label>
          <b-form-input
            v-model="form.date"
            :id="`input-role_code`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Company Name</label>
          <b-form-input
            v-model="form.company"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role_code`">Roles</label>
          <b-form-input
            v-model="form.role"
            :id="`input-role_code`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Outlet Category</label>
          <b-form-input
            v-model="form.outlet_cat"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role_code`">Outlet Name</label>
          <b-form-input
            v-model="form.outlet_name"
            :id="`input-role_code`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-size`">Product Type</label>
          <b-form-input
            v-model="form.type"
            id="input-horizontal"
            type="text"
            required
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <TableStockoutView
      :grand="grandP"
      :fields="fields"
      :items="items"
      :id="this.$route.query.id"
      :cat="this.$route.query.cat"
    />

    <b-row align="right">
      <b-col>
        <b-button variant="primary" size="sm" @click="onClickBack">
          BACK</b-button
        >
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import TableStockoutView from "@/table/user/stockout/TableStockoutView";

export default {
  data() {
    return {
      grandP: "",
      items: [],
      form: {
        name: "",
        date: "",
        company: "",
        role: "",
        outlet_cat: "",
        outlet_name: "",
        type: ""
      },
      fields: [
        {
          label: "No",
          key: "no",
          sortable: false
        },
        {
          label: "Product Name",
          key: "name",
          sortable: true
        },
        {
          label: "SKU",
          key: "sku",
          sortable: true
        },
        {
          label: "Quantity",
          key: "quantity",
          sortable: true
        },
        {
          label: "Price (RM)",
          key: "price",
          sortable: false
        },
        {
          label: "Total Price",
          key: "totalPrice",
          sortable: false
        }
      ]
    };
  },
  created() {
    this.showStockout();
    this.form.type =
      parseInt(this.$route.query.pro_cat) === 1 ? "UHT" : "Pasteurized";
  },
  methods: {
    showStockout() {
      this.$store
        .dispatch("showStockout", {
          category: this.$route.query.cat,
          stock_id: this.$route.query.id
        })
        .then(res => {
          let price = 0;
          if (res.data.response.code === 100) {
            this.form.id = this.$route.query.id;
            this.form.name = res.data.data.userdetails.name;
            this.form.date = res.data.data.date;
            this.form.company = res.data.data.userdetails.company;
            this.form.role = res.data.data.userdetails.role_details.desc;
            this.form.outlet_cat = res.data.data.outlet.name;
            this.form.outlet_name = res.data.data.outlet_name;
            res.data.data.pro_stock.forEach(element => {
              let defPrice = parseFloat(element.price);
              price += defPrice;
              this.items.push({
                name: element.product.name,
                sku: element.product_id,
                quantity: element.quantity,
                price: element.price,
                totalPrice: element.total_price_pu
              });
            });
            this.grandP = price;
          }
        });
    },
    onClickBack() {
      this.$router.go(-1);
    }
  },
  components: {
    TableStockoutView
  }
};
</script>
<style lang="css" scoped></style>
